import React, {Component} from 'react';
import {Button} from 'semantic-ui-react';
import {Redirect} from 'react-router';

export default class FeaturedTourThumb extends Component{
	constructor(props){
		super(props);
		this.state = {
			data: this.props.data,
			index: this.props.index,
			thumbnail: this.props.thumbnail,
			name: this.props.name,
			description: this.props.description,
			days: this.props.days,
			href: this.props.href,
			alt: this.props.name,
            hideText: true,
			hover: false
		};
	}
	
	redirectPage = () => {
		this.setState({redirect: true});
		window.scrollTo(0, 110)
	}

	hoverOn = () => this.setState({hover: true, hideText: false});
	hoverOff = () => this.setState({hover: false, hideText: true});
	
	render(){
		let title;
		let {data, index, thumbnail, name, description, days, href} = this.props;
		let {hideText, hover, redirect} = this.state;
		if(data[index].active === "true"){
			title = (
				
				<div className="overlay-blue" hidden={data[index].active === "true" ? false : true}>	
					{redirect &&
						<Redirect push to={href}/>
					}
					<div className="display-table">
						<div className="display-table-cell">					
							<p className="tour-name">{name}</p>
							<p className="tour-description">{description}</p>
							<p className="tour-description">{days}</p>
							<Button color="orange" onClick={this.redirectPage}>See full details</Button>
						</div>
					</div>
				</div>
			);
		}
		else{
			title = (
				<div className="overlay-blue" hidden={hideText}>	
					<div className="display-table hover-thumb">
						<div className="display-table-cell">
							<p className="tour-name">{name}</p>
							<p className="tour-description">{description}</p>
							<p className="tour-description">{days}</p>
							<Button color="orange" onClick={this.redirectPage}>See full details</Button>
						</div>
					</div>
				</div>
			);
		}
		return (
			
			<div onMouseEnter={this.hoverOn} onMouseLeave={this.hoverOff}>
				<div className='thumb'>
					<img
						alt=""
						src={thumbnail}
						className={hover ? 'thumb-hover' : 'thumb-hover-leave'}
					/>
					<div className="overlay-blue-title overlay-title-bottom" hidden={data[index].active === "true" || hover ? true : false}>
						<div className="display-table hover-thumb">
							<div className="display-table-cell">
								<p className="tour-name">{name}</p>
							</div>
						</div>
					</div>
					{title}
				
				</div>
			</div>
		);
	}
}
